import CertificateForm from './CertificateForm';

export default CertificateForm;
